import { mapValues } from 'lodash';
/**
 * Version 11 migrating new settings for the Agenda Widget.
 */
export default function v11(website) {
  return {
    ...website,
    eventVersion: 11,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'Agenda' && !layoutItem.config.style.sessionItem) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            style: {
              ...layoutItem.config.style,
              sessionItem: {
                styleMapping: 'custom',
                background: {
                  image: null,
                  color: 'primary',
                  borderRadius: 0
                },
                border: {
                  color: 'text',
                  thickness: 0,
                  borderStyle: 'solid'
                },
                spacing: {
                  padding: {
                    paddingBottom: 20,
                    paddingTop: 20,
                    paddingLeft: 20,
                    paddingRight: 20
                  }
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
